import { useState, useEffect } from "react";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { tokenDecode } from "../../utils/helper";
import { config } from "../../utils/config";
import "../../index.css"
import { Tag } from "antd";
import { useHistory } from "react-router-dom";

const { apiEndpoint } = config;

interface ICustomer {
  id: any;
}
const AddUser = () => {
  let params: ICustomer = useParams();
  const { id } = params;
  const history = useHistory();
  const [pageNamem, setpageName] = useState(true);

  const [loading, setLoading] = useState(false);
  const [uploading, setUpLoading] = useState(false);
  const decode = tokenDecode();
  const [roleData, setRoleData] = useState([]);

  const rawData = {
    name: "",
    email: "",
    contact_no: "",
    seller_id: decode?.data?.user?.seller_id,
    role_id: "",
    status: false,
  };
  const errorRawData = {
    name: false,
    email: false,
    contact_no: false,
    role_id: false,
  };
  const [userData, setUserData]: any = useState(rawData);
  const [userDataError, setUserDataError]: any = useState(errorRawData);

  const inputHandler = (e: any) => {
    const { name, value } = e.target;
    if (name === "name") {
      let cleaned = value.replace(/[^a-zA-Z0-9\s]/g, "");
      cleaned = cleaned.replace(/^[^a-zA-Z]+/, "");
      setUserData({ ...userData, [name]: cleaned });
      if (cleaned.trim()) {
        setUserDataError({ ...userDataError, [name]: "valid" });
      } else {
        setUserDataError({ ...userDataError, [name]: true });
      }
      return;
    }
    setUserData({ ...userData, [name]: value });
  };
  const errorHandler = (e: any) => {
    const { name, value } = e.target;
    if (!value || (typeof value === "string" && !value.trim())) {
      setUserDataError({ ...userDataError, [name]: true });
    } else if (name === "name" && !/^[a-zA-Z][a-zA-Z0-9\s]*$/.test(value.trim())) {
      setUserDataError({ ...userDataError, [name]: "invalid" });
    } else if (name === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())) {
      setUserDataError({ ...userDataError, [name]: "invalid" });
    } else if (name === "contact_no" && !/^[0-9]{10}$/.test(value.toString().trim())) {
      setUserDataError({ ...userDataError, [name]: "invalid" });
    } else {
      setUserDataError({ ...userDataError, [name]: "valid" });
    }
  };
  const getRole = async () => {
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/snp/roles/getall`,
        method: "GET",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: {
          seller_id: decode?.data?.user?.seller_id,
        },
      });
      // console.log("role listing", data);
      if (data.status === true) {
        setRoleData(data?.roles);
      }
    } catch (error) { }
  };
  const newUserCreatehandler = async () => {
    if (loading) return;
    const { name, email, contact_no, role_id } = userData;

    const nameRegex = /^[a-zA-Z][a-zA-Z0-9\s]*$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const contactRegex = /^[0-9]{10}$/;

    let newErrors: any = { ...userDataError };
    let hasError = false;

    if (!name || !name.trim() || !nameRegex.test(name.trim())) {
      newErrors.name = !name || !name.trim() ? true : "invalid";
      hasError = true;
    } else {
      newErrors.name = "valid";
    }

    if (!email || !email.trim() || !emailRegex.test(email.trim())) {
      newErrors.email = !email || !email.trim() ? true : "invalid";
      hasError = true;
    } else {
      newErrors.email = "valid";
    }

    if (!contact_no || !contactRegex.test(contact_no.toString().trim())) {
      newErrors.contact_no = !contact_no ? true : "invalid";
      hasError = true;
    } else {
      newErrors.contact_no = "valid";
    }

    if (!role_id) {
      newErrors.role_id = true;
      hasError = true;
    } else {
      newErrors.role_id = "valid";
    }

    setUserDataError(newErrors);

    if (hasError) {
      toast.error("Please fill all required fields correctly!");
      return;
    }

    setLoading(true);
    try {
      const response = await axios({
        url: `${apiEndpoint}/snp/users/create`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: userData,
      });

      const resData = response?.data;
      console.log("User create response:", resData);

      if (resData?.status === true || resData?.status === 200 || resData?.success === true) {
        toast.success(resData?.message || "User created successfully!");
        setUserData(rawData);
        setUserDataError(errorRawData);
        history.push("/userlist")
      } else {
        // Dynamic API Error Message (e.g. "Email already exists!")
        toast.error(resData?.message || resData?.error || "Failed to create user!");
      }
    } catch (error: any) {
      console.error("Create User Error:", error);
      const apiErrorMessage = error?.response?.data?.message || error?.response?.data?.error || error?.message || "Failed to create user!";
      toast.error(apiErrorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRole();
  }, []);
  return (
    <>
      <ThemeMaker>
        <div className="row w-100 m-0 mt-2">
          <div className="col-md-12 ">
            <div className="mb-4">
              <div className=" py-3">
                {/* <h6 className="m-0 font-weight-bold text-primary">
                  {pageNamem ? "Add a new user" : "Update user"}
                </h6> */}
              </div>
              <div className="" style={{ minHeight: "70vh" }}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="genericlabel">Name
                        <span className="text-danger" > * </span>
                        {userDataError?.name === true && <span className="text-danger tiny_size" > This field is required ! </span>}
                        {userDataError?.name === "invalid" && <span className="text-danger tiny_size" > Name must start with an alphabet and cannot contain special characters! </span>}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        maxLength={50}
                        name="name"
                        placeholder="Enter name"
                        value={userData.name}
                        onChange={(e) => inputHandler(e)}
                        onBlur={(e) => errorHandler(e)}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="genericlabel">Email address
                        <span className="text-danger" > * </span>
                        {userDataError?.email === true && <span className="text-danger tiny_size" > This field is required ! </span>}
                        {userDataError?.email === "invalid" && <span className="text-danger tiny_size" > Please enter a valid email address ! </span>}
                      </label>
                      <input
                        type="text"
                        name="email"
                        className="form-control"
                        placeholder="Enter email"
                        value={userData.email}
                        onChange={(e) => inputHandler(e)}
                        onBlur={(e) => errorHandler(e)}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">

                      <label className="genericlabel">Contact
                        <span className="text-danger" > * </span>
                        {userDataError?.contact_no === true && <span className="text-danger tiny_size" > This field is required ! </span>}
                        {userDataError?.contact_no === "invalid" && <span className="text-danger tiny_size" > Contact number must be exactly 10 digits ! </span>}
                      </label>

                      <input
                        type="text"
                        name="contact_no"
                        className="form-control"
                        placeholder="Enter contact "
                        maxLength={10}
                        value={userData.contact_no}
                        onChange={(e) => {
                          const val = e.target.value.replace(/\D/g, "").slice(0, 10);
                          setUserData({ ...userData, contact_no: val });
                        }}
                        onBlur={(e) => errorHandler(e)}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="genericlabel">Role
                        <span className="text-danger" > * </span>
                        {
                          userDataError?.role_id !== "valid" && userDataError?.role_id !== false ? (
                            <span className="text-danger tiny_size" > This field is required ! </span>
                          ) : null
                        }
                      </label>
                      <select
                        name="role_id"
                        className="form-control"
                        id=""
                        onChange={(e) => inputHandler(e)}
                        onBlur={(e) => errorHandler(e)}
                      >
                        <option value="">Select role</option>
                        {roleData
                          .filter((roleData: any) => {
                            if (roleData.status) {
                              return roleData;
                            }
                          })
                          .map((item: any) => (
                            <option value={item?.id}>
                              {" "}
                              {item?.role_name}{" "}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group d-flex align-items-center">
                      <label className="genericlabel m-0">Status</label>
                      {/* <br /> */}
                      <input
                        type="checkbox"
                        className="d-inline-block " style={{ marginLeft: "7px" }}
                        checked={userData.status}
                        value={userData.contact_no}
                        onChange={(e) =>
                          setUserData({ ...userData, status: !userData.status })
                        }
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <Tag
                      color="blue"
                      style={{
                        cursor: loading ? "not-allowed" : "pointer",
                        opacity: loading ? 0.6 : 1,
                        pointerEvents: loading ? "none" : "auto",
                        padding: "6px 14px",
                        fontWeight: "500",
                        userSelect: "none",
                      }}
                      onClick={loading ? undefined : newUserCreatehandler}
                    >
                      {loading ? "saving..." : "Save"}
                    </Tag>
                  </div>
                  {/* <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ThemeMaker>
    </>
  );
};

export default AddUser;
